import carrierFormInputSaga from '~/sagas/carrier-form-input/carrier-form-input.saga';

export default carrierFormInputSaga;
